<template>
  <div class="fast-reply inter">
    <div class="flex-center search">
      <span class="goBack" @click="linkBack"> <van-icon name="arrow-left" />返回 </span>
      <!-- <van-dropdown-menu class="search-select">
        <van-dropdown-item v-model="groupId" :options="groupOptions" @change="search" />
      </van-dropdown-menu> -->
      <van-dropdown-menu class="search-select">
        <van-dropdown-item v-model="type" :options="typeOptions" @change="search" />
      </van-dropdown-menu>
    </div>
    <div class="flex-center mar-bott special_padding">
      <van-search class="flex1" v-model="radarName" @clear="clearInp" placeholder="搜索雷达内容" />
      <span @click="search" class="search-text" :style="{ color: radarName ? '#277FFF' : '' }">搜索</span>
    </div>
    <p class="special_padding total-num">共{{ interData.length || 0 }}个雷达</p>
    <van-list v-model="loading" :finished="finished" loading-text="加载中..." :finished-text="finishedtext" @load="load_more" :immediate-check="false">
      <div class="inter-content">
        <div v-for="item in interData" :key="item.id" class="content-li">
          <h4 class="flex-center">
            <van-icon class="tree-two-icon" :name="require('@/assets/images/sendchoose.png')" />
            {{ item.name }}
          </h4>
          <div @click="shareList(item)" class="flex-center">
            <van-icon class="tree-third-icon" :name="require('@/assets/images/sendnormal.png')" />
            <div class="li-text flex-center">
              <img v-if="item.siteImg && item.type == 2" alt="" v-lazy="item.siteImg" />
              <img v-else-if="item.type == 1" alt="" v-lazy="require('@/assets/images/pdf.png')" />
              <img v-else alt="" v-lazy="require('@/assets/images/site.png')" />

              <div class="li-text-btn">
                <div class="li-div">
                  <p class="li-title">{{ item.siteName }}</p>
                  <!-- <span class="li-text-size">2390</span> -->
                </div>
                <span class="blue-text" v-if="item.type == 1" @click="lookText($event, item)">查看</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="show" position="bottom" closeable :style="{ height: '70%' }" round @closed="closePopup">
      <div class="detail-popup">
        <div id="pdf-detail"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { weradarList, weRadarEncrypt } from "@/server/api.js";
import { Toast } from "vant";
import Pdfh5 from "pdfh5";
import { addressBar, wefunstatistics } from "@/utils/public";
import { wxConfig } from "./js/config";
import "pdfh5/css/pdfh5.css";
export default {
  data() {
    return {
      type: "",
      groupId: "",
      groupOptions: [{ value: "", text: "全部" }],
      typeOptions: [
        { text: "全部", value: "" },
        { text: "PDF", value: 1 },
        { text: "网站", value: 2 },
      ],
      show: false,
      radarName: "",
      pageNum: 0,
      pageSize: 7,
      interData: [],
      loading: false,
      finished: false,
      finishedtext: "没有更多了",
      userId: "",
      wechatUserId: "",
      jsList: ["getCurExternalContact", "sendChatMessage"],
      pdfh5: null,
      windowurl: window.location.href.split("#")[0] || "https://xyqw.xinyuanhulian.com/reply",
    };
  },

  async mounted() {
    if (localStorage.getItem("token")) {
      wxConfig(this.windowurl, this.jsList).then(async () => {
        await this.getWechatId();
        this.groupId = this.$route.query.id;
        this.interSearch();
        await wefunstatistics("16", window.location.href.split("#")[0]);
      });
    } else {
      addressBar("token", this.windowurl);
    }
  },

  methods: {
    getWechatId() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.wechatUserId = res.userId;
        }
      });
    },
    interSearch() {
      this.loading = true;
      weradarList({
        type: this.type,
        groupId: this.groupId,
        radarName: this.radarName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res.code !== "200") {
          Toast.fail(res.msg);
          this.finished = true;
          this.finishedtext = res.msg;
          return;
        }
        this.interData = this.interData.concat(res.data.list);
        if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
          //数据全部加载完成
          this.finished = true;
        } else {
          this.finished = false;
        }
      });
    },
    search() {
      this.pageNum = 1;
      this.interData = [];
      this.interSearch();
    },
    load_more() {
      this.pageNum++;
      this.interSearch();
    },
    // listgroup() {
    //   selGroup().then((res) => {
    //     if (res.code !== "200") return Toast.fail(res.msg);
    //     res.data.map((v) => {
    //       v.text = v.name;
    //       v.value = v.id;
    //     });
    //     this.groupOptions = [{ value: "", text: "全部" }, ...res.data];
    //   });
    // },
    closePopup() {
      this.show = false;
      this.pdfh5 = null;
    },
    lookText(e, obj) {
      e.stopPropagation();
      this.show = true;
      this.$nextTick(() => {
        this.pdfh5 = new Pdfh5("#pdf-detail", {
          pdfurl: obj.siteUrl,
          maxZoom: 3,
          lazy: true,
          scrollEnable: true,
          clientheight: 0,
        });
      });
    },
    linkBack() {
      this.$router.push("/reply");
      localStorage.setItem("replytab", "inter");
    },
    clearInp() {
      this.pageNum = 1;
      this.radarName = "";
      this.interData = [];
      this.interSearch();
    },
    async shareList(obj) {
      this.userId = localStorage.getItem("userid");
      let pdfimg = "http://qfzy.static.1000phone.net/img/2023-06-05/ag7ZU4MdvJuO4xMk/pdf.png";
      let siteimg = "http://qfzy.static.1000phone.net/img/2023-06-05/3W12xTBHw8uz5P2a/site.png";
      let data = await weRadarEncrypt({
        fileId: obj.id,
        userId: this.userId,
        wechatId: this.wechatUserId,
      });
      let parmStr = data.data;
      if (data.code !== "200") return Toast.fail(data.msg);
      wx.invoke(
        "sendChatMessage",
        {
          msgtype: "news",
          enterChat: false,
          news: {
            // link: `${process.env.VUE_APP_API_HOST}weradarreading/urlRedirect/${parmStr}`,
            link: `${window.location.origin}/openFile?name=${encodeURIComponent(parmStr)}`,
            title: obj.name,
            desc: "",
            imgUrl: obj.type === 1 ? pdfimg : obj.siteImg ? obj.siteImg : siteimg,
          },
          // msgtype: "text",
          // enterChat: true,
          // text: {
          //   content: `${obj.name}:${window.location.origin}/openFile?name=${parmStr}`, //文本内容
          // },
        },
        function (res) {
          if (res.err_msg == "sendChatMessage:ok") {
            //发送成功
            Toast.success("发送成功");
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="less">
@import "./css/fastReply";
.inter {
  .search {
    padding: 20px 0 20px 30px;
    .goBack {
      height: 48px;
      font-size: 28px;
    }
  }
  .total-num {
    font-size: 26px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  /deep/.search-select {
    padding-top: 8px;
    .van-cell__title {
      font-size: 26px;
    }
    .van-dropdown-menu__bar {
      box-shadow: none;
      height: auto;
      margin-top: -12px;
      .van-dropdown-menu__item {
        width: 160px;
        flex: inherit;
        .van-dropdown-menu__title {
          height: 100%;
          display: inline-block;
          .van-ellipsis {
            font-size: 26px;
            padding-top: 5px;
            line-height: 24px;
          }
        }

        .van-dropdown-menu__title::after {
          border: 7px solid;
          border-color: transparent transparent #dcdee0 #dcdee0;
          right: -12px;
        }
      }
    }
  }
  .detail-popup {
    padding: 100px 40px 20px;
    width: 100%;
    height: 100%;
    #pdf-detail {
      width: 100%;
      height: 100%;
    }
  }
  .inter-content {
    padding: 0 30px;
    .content-li {
      background: #f1f6ff;
      border-radius: 14px;
      padding: 24px 30px 40px;
      margin-bottom: 30px;
      h4 {
        font-size: 26px;
        margin-bottom: 24px;
        font-weight: normal;
      }
      .tree-two-icon {
        width: 36px;
        font-size: 36px;
        margin-right: 12px;
      }
      .tree-third-icon {
        margin-right: 14px;
        img {
          width: 36px;
        }
      }
      .li-text {
        width: 100%;
        img {
          width: 80px;
          height: 80px;
        }
        .li-text-btn {
          width: 100%;
          margin-left: 20px;
          font-size: 26px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .li-div {
            flex: 1;
          }
          .li-title {
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .blue-text {
            width: 70px;
            padding-left: 10px;
            flex-shrink: 1;
            color: #277fff;
            cursor: pointer;
          }
          .li-text-size {
            font-size: 24px;
            color: #999999;
            margin-top: 7px;
          }
        }
      }
    }
  }
}
</style>
